import React from 'react'
import { css } from '@emotion/react'

import { cssFullWidth } from '@/styles/general'
import {
  SvgArrow,
  SvgMore,
  SvgArrowProps,
  SvgMoreProps
} from '@/components/svg'

type MoreDetailProps = {
  ArrowIcon?: React.FC<SvgArrowProps>
  arrowIconProps?: SvgArrowProps
  MoreIcon?: React.FC<SvgMoreProps>
  moreIconProps?: SvgMoreProps
}

export const MoreDetail = ({
  ArrowIcon = SvgArrow,
  MoreIcon = SvgMore,
  arrowIconProps,
  moreIconProps
}: MoreDetailProps): JSX.Element => {
  return (
    <div css={cssMoreDetails}>
      <span>More detail</span>
      <div css={cssIconWrapper}>
        <ArrowIcon {...arrowIconProps} label="外部ページへのリンク" />
      </div>
      <div css={cssIconWrapper}>
        <MoreIcon {...moreIconProps} css={cssFullWidth} />
      </div>
    </div>
  )
}

const cssMoreDetails = css`
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1.4px;
`

const cssIconWrapper = css`
  display: flex;
  align-items: center;
  width: 14px;
  margin-left: 8px;
  &:first-of-type {
    width: 12px;
    margin-left: 2px;
  }
`
